import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-62" data-mp="29vxtj2pqjjl">
      <Header data-id="element-63" data-mp="2bgrl6h7dyge" />
      <main className="flex-1" data-id="element-64" data-mp="27sz8anhvi39">
        <Outlet data-id="element-65" data-mp="gz1rkris7hk3" />
      </main>
      <Footer data-id="element-66" data-mp="gzbjikndzysf" />
    </div>;
}